(ns renolit-roofing-service.view.installer-home
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.navigation :as nav]
            [renolit-roofing-service.service.service :as srv.service]
            [renolit-roofing-service.user :as client.user]
            [renolit-roofing-service.layout.display-item :as layout.display-item]
            [renolit-roofing-service.layout.user-layout :as user-layout]
            [renolit-roofing-service.shared.util.time :as shared.time]
            [renolit-roofing-service.util.localization :as util.localization]
            [renolit-roofing-service.view :as view]))

(def ^:const route-config
  {:name [:installer-home]
   :auth-req? true
   :parameters {}
   :controllers [{:start #(rf/dispatch [::view.on-enter %])
                  :stop #(rf/dispatch [::view.on-leave %])}]})

(def ^:const entity-key :installer-services)

(rf/reg-event-fx
 ::view.on-enter
 (fn [_ _]
   {:fx [[:dispatch [::srv.service/fetch-services-with-projects
                     {:on-success-evt [::services-loaded]}]]]}))

(rf/reg-event-fx
 ::view.on-leave
 (fn [{:keys [_]} _]))

(rf/reg-event-db
 ::services-loaded
 (fn [db _]
   db))

(rf/reg-sub
 ::services-with-projects
 (fn [db]
   (let [services (get db :services)
         project-cache (:installer-project-cache db {})]
     (map (fn [service]
            (let [project (get project-cache (:project-id service))]
              (assoc service :project project)))
          services))))

(def ^:private submitted-statuses
  #{"laboratory" "diagnosis-closed"
    :laboratory :diagnosis-closed})

(rf/reg-sub
 ::in-progress-services
 :<- [::services-with-projects]
 (fn [services _]
   (->> services
        (remove #(submitted-statuses (:status %)))
        (sort-by (comp count :reviews))
        reverse)))

(rf/reg-sub
 ::completed-services
 :<- [::services-with-projects]
 (fn [services _]
   (->> services
        (filter #(submitted-statuses (:status %)))
        (sort-by (comp count :reviews))
        reverse)))

(defn- service-card
  [{:keys [project reason created-at name reason inspector id last-maintenance-date] :as service}
   {:keys [completed?]}]
  (let [{:keys [project/name project/number project-number]} project
        project-code (or number project-number)
        {:keys [building-street building-zip building-city building-state]} project
        display-address (->> [building-street
                              (when (and building-zip building-city)
                                (str building-zip " " building-city))
                              building-state]
                             (remove nil?)
                             (str/join ", "))
        display-address (when-not (str/blank? display-address) display-address)]
    [:div.card.service-card
     [:div.card__header
      [:span.card__title (:number project)]
      [:span.card__subtitle (shared.time/format-date (or created-at last-maintenance-date) {})]]
     [:div.service-card__project-name (:name project)]
     [:div.card__content
      [layout.display-item/main
       {:type :text
        :value (:name service)
        :label-transl-kw :domain.service/name}]
      [layout.display-item/main
       {:type :text
        :value (util.localization/dropdown-value :service-reason (:reason service))
        :label-transl-kw :domain.service/reason}]
      [layout.display-item/main
       {:type :text
        :value display-address
        :label-transl-kw :domain.project/address}]]
     [:div.card__actions
      [:a.btn.btn--primary.btn--anchor {:href (nav/href [:installer-service-detail] {:id id})
                                        :on-click #(when-not completed?
                                                     (rf/dispatch [::srv.service/mark-service-status-as-field-visit id]))}
       (if completed?
         (t [:page.installer.home.edit-diagnostics])
         (t [:page.installer.home.start-diagnostics]))]]]))

(defn- tabs
  []
  (let [active-tab (rf/subscribe [::active-tab])]
    (fn []
      [:div.installer-tabs.tab-bar.tab-bar--pill
       [:div.installer-tab.tab-bar__tab
        {:class (when (= :in-progress @active-tab) "tab-bar__tab--selected")
         :on-click #(rf/dispatch [::set-active-tab :in-progress])}
        (t [:page.installer.home.tabs.in-progress])]
       [:div.installer-tab.tab-bar__tab
        {:class (when (= :completed @active-tab) "tab-bar__tab--selected")
         :on-click #(rf/dispatch [::set-active-tab :completed])}
        (t [:page.installer.home.tabs.completed])]])))

(rf/reg-event-db
 ::set-active-tab
 (fn [db [_ tab]]
   (assoc db :installer-active-tab tab)))

(rf/reg-sub
 ::active-tab
 (fn [db _]
   (get db :installer-active-tab :in-progress)))

(defn- services-list
  [services opts]
  [:div
   (if (seq services)
     [:div.installer-services-list
      (for [service services]
        ^{:key (:id service)}
        [service-card service opts])]
     [:div.installer-empty-state
      [:p (t [:page.installer.home.no-services])]])])

(defn- main*
  []
  (let [active-tab (rf/subscribe [::active-tab])
        in-progress-services (rf/subscribe [::in-progress-services])
        completed-services (rf/subscribe [::completed-services])]
    (fn []
      [:div.installer-home
       [tabs]
       [:div.installer-home__content
        (case @active-tab
          :in-progress [services-list @in-progress-services {:completed? false}]
          :completed [services-list @completed-services {:completed? true}]
          [services-list @in-progress-services {:completed? false}])]])))

(defn- main
  []
  (let [user (rf/subscribe [::client.user/user-data])]
    (fn []
      (let [{:keys [first-name]} @user]
        [user-layout/main
         {:header-title (t [:page.home.user-greetings] [first-name])}
         [main*]]))))

(defmethod view/view-display (:name route-config)
  [_]
  [main])
